import { render } from "./FR.IA.03.vue?vue&type=template&id=0f819250&ts=true"
import script from "./FR.IA.03.vue?vue&type=script&lang=ts"
export * from "./FR.IA.03.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/SchemaByFormCode/FR.IA.03.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0f819250"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0f819250', __exports__)) {
    api.reload('0f819250', __exports__)
  }
  
  module.hot.accept("./FR.IA.03.vue?vue&type=template&id=0f819250&ts=true", () => {
    api.rerender('0f819250', render)
  })

}


export default __exports__